import { apiClient } from './client'

export interface Group {
  id: string
  name: string
  description: string
  memberCount: number
  isActive: boolean
  createdAt: string
  createdBy: string
  updatedAt: string
}

export interface GroupStats {
  total: number
  active: number
  inactive: number
  totalMembers: number
}

export interface CreateGroupRequest {
  name: string
  description: string
}

export interface UpdateGroupRequest {
  name?: string
  description?: string
  isActive?: boolean
}

export const groupsApi = {
  // Get all groups
  getGroups: async (): Promise<Group[]> => {
    const response = await apiClient.get('/groups')
    return response.data.data
  },

  // Get single group by ID
  getGroup: async (id: string): Promise<Group> => {
    const response = await apiClient.get(`/groups/${id}`)
    return response.data.data
  },

  // Create new group
  createGroup: async (groupData: CreateGroupRequest): Promise<Group> => {
    const response = await apiClient.post('/groups', groupData)
    return response.data.data
  },

  // Update group
  updateGroup: async (id: string, groupData: UpdateGroupRequest): Promise<Group> => {
    const response = await apiClient.put(`/groups/${id}`, groupData)
    return response.data.data
  },

  // Delete group
  deleteGroup: async (id: string): Promise<void> => {
    await apiClient.delete(`/groups/${id}`)
  },

  // Get group statistics
  getGroupStats: async (): Promise<GroupStats> => {
    const response = await apiClient.get('/groups/stats')
    return response.data.data
  }
}